<template>
  <div class="main-movie-container as-flex main-center cross-center">
    <div class="main-poster as-flex main-center cross-center">
      <img
        v-if="mainMovieInfo.poster_url"
        :src="mainMovieInfo.poster_url"
        class="poster-img"
        alt="主影片海报"
      >
      <img v-else src="../../assets/images/movie-poster.png" class="poster-img" alt="主影片海报">
    </div>
    <div class="main-info as-flex flex-vertical main-start cross-center">
      <div class="top-maininfo as-flex main-between cross-end">
        <div class="left-title f-3 as-flex main-start cross-end">
          <span class="movie-title as-nowrap">{{mainMovieInfo.title || '--'}}</span>
          <clickSlider class="movie-tags as-nowrap" :movieTags="mainMovieInfo.tags">
            <!-- <div class="as-full-width as-full-height as-flex main-start cross-end">
              <template v-for="(item,index) in mainMovieInfo.tags">
                <span :key="'tag_' + index" class="tag-item f-1 as-nowrap">{{item}}</span>
              </template>
            </div>-->
          </clickSlider>
          <!-- <span class="tag-item f-1">喜剧</span>
          <span class="tag-item f-1">中国</span>-->
        </div>
        <div class="right-time f-1 fc-gray-2 as-nowrap">{{mainMovieInfo.launch + '上映'}}</div>
      </div>
      <div class="bottom-detail as-flex main-start cross-center">
        <div class="left-hot-index as-flex flex-vertical main-start cross-start">
          <div class="as-flex flex-vertical main-start cross-start f-2">
            <div class="half-title as-flex main-start cross-end f-2">
              <span>热度指标</span>
              <el-tooltip
                class="item"
                effect="dark"
                content="热度指标包括认知度、兴趣度、首选度，适用于映前的市场分析"
                placement="top"
              >
                <img
                  tabindex="0"
                  class="question-tip-icon icon-2"
                  src="../../assets/images/question@3x.png"
                >
              </el-tooltip>
              <span class="f-1 fc-gray-2">({{offsetMapping[mainMovieInfo.offset]}})</span>
            </div>
            <div class="half-line as-full-width as-flex main-start cross-end f-1 fc-gray-2">
              <span class="tag-title">认知</span>
              <span
                class="tag-value"
              >{{mainMovieInfo.awareness&&mainMovieInfo.awareness.value?mainMovieInfo.awareness.value+"%" : '--'}}</span>
              <span>(均值{{mainMovieInfo.awareness?mainMovieInfo.awareness.average+"%":"--"}})</span>
            </div>
            <div class="half-line as-full-width as-flex main-start cross-end f-1 fc-gray-2">
              <span class="tag-title">兴趣</span>
              <span
                class="tag-value"
              >{{mainMovieInfo.interest&&mainMovieInfo.interest.value?mainMovieInfo.interest.value+"%" : '--'}}</span>
              <span>(均值{{mainMovieInfo.interest?mainMovieInfo.interest.average+"%":"--"}})</span>
            </div>
            <div class="half-line as-full-width as-flex main-start cross-end f-1 fc-gray-2">
              <span class="tag-title">首选</span>
              <span
                class="tag-value"
              >{{mainMovieInfo.primary&&mainMovieInfo.primary.value?mainMovieInfo.primary.value+"%" : '--'}}</span>
              <span>(均值{{mainMovieInfo.primary?mainMovieInfo.primary.average+"%":"--"}})</span>
            </div>
          </div>
        </div>
        <div class="right-rating-index as-flex flex-vertical main-start cross-center">
          <div class="as-flex flex-vertical main-start cross-center f-2">
            <div class="half-title as-full-width as-flex main-start cross-end f-2">
              <span>口碑指标</span>
              <el-tooltip
                class="item"
                effect="dark"
                content="口碑指标包括喜爱度、推荐度、与其达成，适用于映后的市场分析"
                placement="top"
              >
                <img
                  tabindex="0"
                  class="question-tip-icon icon-2"
                  src="../../assets/images/question@3x.png"
                >
              </el-tooltip>
              <span class="f-1 fc-gray-2">({{offsetMapping[mainMovieInfo.offset]}})</span>
            </div>
            <div class="half-line as-full-width as-flex main-between cross-end f-1 fc-gray-2">
              <span class="tag-title">喜爱&nbsp&nbsp</span>
              <span
                class="tag-value"
              >{{mainMovieInfo.rating&&mainMovieInfo.rating.value?mainMovieInfo.rating.value+"%" : '--'}}</span>
              <span>(均值{{mainMovieInfo.rating?mainMovieInfo.rating.average+"%":"--"}})</span>
            </div>
            <div class="half-line as-full-width as-flex main-between cross-end f-1 fc-gray-2">
              <span class="tag-title">推荐&nbsp&nbsp</span>
              <span
                class="tag-value"
              >{{mainMovieInfo.recommendation&&mainMovieInfo.recommendation.value?mainMovieInfo.recommendation.value+"%" : '--'}}</span>
              <span>(均值{{mainMovieInfo.recommendation?mainMovieInfo.recommendation.average+"%":"--"}})</span>
            </div>
            <div class="half-line as-full-width as-flex main-between cross-end f-1 fc-gray-2">
              <span class="tag-title">预期达成</span>
              <span
                class="tag-value"
              >{{mainMovieInfo.expectation&&mainMovieInfo.expectation.value?mainMovieInfo.expectation.value+"%" : '--'}}</span>
              <span>(均值{{mainMovieInfo.expectation?mainMovieInfo.expectation.average+"%":"--"}})</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const offsetMapping = {
  "1.0": "映后一周",
  "0.0": "上映当周",
  "-1.0": "映前一周",
  "-2.0": "映前两周",
  "-3.0": "映前三周",
  "-4.0": "映前四周"
};
import movieApi from "../../api/movieApi.js";
import clickSlider from "../common/horizontalPrevNextSlider";
export default {
  name: "mainMovieBox",
  props: {
    mainMovieId: {}
  },
  components: {
    clickSlider: clickSlider
  },
  data() {
    return {
      offsetMapping: offsetMapping,
      movieApi: new movieApi(),
      mainMovieInfo: {
        title: "一出好戏",
        launch: "2014-07-08"
      }
    };
  },
  computed: {},
  methods: {
    async initMovieInfo(id) {
      let res = await this.movieApi.getSingleMovieBasicInfo({
        id: id || this.mainMovieId
      });
      if (res.code !== 200 || res.status !== true) {
        throw new Error("获取主电影信息失败");
      }
      this.mainMovieInfo = res.data;
    }
  },
  async mounted() {
    this.initMovieInfo();
  },
  watch: {
    mainMovieId: function(to, from) {
      this.initMovieInfo(to);
    }
  }
};
</script>

<style lang="scss" scoped>
.main-movie-container {
  width: 100%;
  height: 100%;
  padding: 10px 10px;
  background-color: #fff;
  overflow: hidden;
}
.main-poster {
  width: 22%;
  height: 100%;
  .poster-img {
    // width: 100%;
    height: 85%;
  }
}
.main-info {
  width: 78%;
  height: 100%;
  padding: 0 10px;
  .top-maininfo {
    width: 100%;
    height: 40px;
    padding-bottom: 10px;
    border-bottom: 1px solid #efefef;
    .left-title {
      color: #333333;
      width: calc(100% - 110px);
      .movie-title {
        min-width: 40px;
        flex-shrink: 0;
      }
      .movie-tags {
        height: 100%;
        flex-grow: 1;
      }
      .tag-item {
        flex-shrink: 0;
        color: #fff;
        margin: 0 0 0 10px;
        background-color: #3085e5;
        border-radius: 3px;
        padding: 1px 5px;
      }
    }
    .right-time {
      width: 100px;
    }
  }
  .bottom-detail {
    width: 100%;
    height: calc(100% - 50px);
    padding: 5px 0px;
    .half-title {
      margin: 8px 0;
    }
    .half-line {
      margin: 3px 0;
      .tag-title {
        margin-right: 10px;
        min-width: 50px;
      }
      .tag-value {
        margin: 0 10px;
        min-width: 40px;
      }
    }
    .question-tip-icon {
      height: 12px;
      width: 12px;
      margin: 3px;
    }
    .left-hot-index {
      height: 100%;
      width: 50%;
      border-right: 1px solid #efefef;
    }
    .right-rating-index {
      height: 100%;
      width: 50%;
      padding-left: 20px;
    }
    .right-rating-index {
    }
  }
}
</style>
